export default __webpack_public_path__ + "static/media/nodeIdsExample.3740a381.png";